import Vue from 'vue';

window._ = require('lodash');

import { stringify } from 'qs';

/**
 * Vue is a modern JavaScript library for building interactive web interfaces
 * using reactive data binding and reusable components. Vue's API is clean
 * and simple, leaving you to focus on building your next great project.
 */

window.Vue = require('vue').default;

/**
 * Zenscroll is a vanilla JavaScript library that enables animated
 * vertical scrolling to an element or position within your
 * document or within a scrollable element (DIV, etc.).
 */

 window.zenscroll = require('zenscroll');

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

const axiosInstance = axios.create({
    headers: {
        'X-CSRF-Token': window.csrfTokenValue,
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/x-www-form-urlencoded'
    },
    transformRequest: [
        function (data) {
            return stringify(data);
        }
    ]
});

Vue.prototype.$axios = axiosInstance;

/**
 * Modernizr tests touchevents.
 */

require('browsernizr/test/touchevents');
require('browsernizr/lib/addTest');
window.Modernizr = require('browsernizr');

window.page = require('page');

window.EventBus = new Vue();

window.mapsCallback = function() {
    EventBus.$emit('google-maps-ready');
};

/**
 * Lottie is a mobile library for Web, and iOS that parses Adobe After Effects animations
 * exported as json with Bodymovin and renders them natively on mobile!
 */
window.lottie = require('lottie-web/build/player/lottie_light');


/**
 * Give our fellow console loggers some love!
 */

console.log('%c Made with 🖤 by 51North: https://51north.nl ', 'background: #fff; color: #000'); // eslint-disable-line

